import React from "react";

const STATUS = {
  Erfasst: { bg: "#DBEAFE", text: "#1E40AF", border: "#BFDBFE" },
  Abgerechnet: { bg: "#DCFCE7", text: "#166534", border: "#BBF7D0" },
  Konflikt: { bg: "#FEF3C7", text: "#92400E", border: "#FDE68A" },
  Abgelehnt: { bg: "#FEE2E2", text: "#991B1B", border: "#FECACA" },
};

export default function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.Erfasst;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border"
      style={{ background: s.bg, color: s.text, borderColor: s.border }}
    >
      {status}
    </span>
  );
}
